import React, { useState } from 'react';
import moment from 'moment';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import { useSelector, useDispatch } from 'react-redux';
import {
    EditContainerMain,
    StyledImage,
    Designation2,
    LineMob,
    Designation3,
    HeaderTextContainer,
    HeaderGridContainer,
    BodyGridContainer,
    Name,
    User1,
    Designation1,
    ValidDate,
    Created,
    Container2,
    UserName,
    Date,
    Line,
    EditIconContainer,
    EditContainer,
    ButtonLabel1,
    DistrictGrid,
    DistrictGridMob,
    TerritoryGridMob,
    DistrictHeading,
    DistrictName,
    TerritoryGrid,
    TerritoryHeading,
    TerritoryName,
    ValidDateMob,
    CreatedByMob,
    ValidDateHeadingMob,
    BodyTextContainer,
    PopupContainer,
    AccountListContainer,
} from './index.styled';
import Edit from 'src/assets/images/Edit.svg';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import UpdateProxy from 'src/pages/admin/updateProxy/index.jsx';
import { useTranslation } from 'react-i18next';
import { setAdminUpdatePopup } from 'src/pages/admin/redux/action';
import { sizes } from 'src/styles/Media.styled';
import { getDisplayDateNoTZ } from 'src/utils/dateUtils';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
const ProxiesTabs2 = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [updateProxy] = useState(false);
    const [proxyData, setproxyData] = useState({});

    useEffectWithErrorLogging(() => {
        dispatch(setAdminUpdatePopup(false));
    }, []);
    const proxyList = useSelector(
        (state) =>
            state.AdminProxyReducer.proxyList &&
            state.AdminProxyReducer.proxyList.proxyRecordsByUser
    );
    const loading = useSelector(
        (state) =>  state.AdminProxyReducer.loading
    );

    // useEffectWithErrorLogging(() => {
    //     dispatch(getProxyList());
    // }, []);

    // useEffectWithErrorLogging(() => {
    //     dispatch(getAdminUserList());
    // }, []);

    const addProxyStatus = useSelector(
        (state) => state.AdminProxyReducer.addProxyStatus
    );

    const updateProxyPopup = useSelector(
        (state) => state.AdminProxyReducer.updatePopup
    );
    const getProxyStatusCode = useSelector((state)=> state.AdminProxyReducer.getProxyStatusCode);
    const [loader, setLoader] = useState(false);
    useEffectWithErrorLogging(()=>{
        if(getProxyStatusCode){
            setLoader(false);
        }
    },[getProxyStatusCode]);

    useEffectWithErrorLogging(() => {
        if (addProxyStatus === '10763') {
            // setshowUpdateProxy(false);
            dispatch(setAdminUpdatePopup(false));
        }
    }, [addProxyStatus]);

    const openUpdateProxy = (listData) => {
        setproxyData(listData);

        // setshowUpdateProxy(true);
        dispatch(setAdminUpdatePopup(true));
    };

    const closeUpdateProxy = () => {
        setproxyData({});
        // setshowUpdateProxy(false);
        dispatch(setAdminUpdatePopup(false));
    };
    return (
        <>
            {(loading || loader) ? (
                <Spinner
                    id="app-loading-spinner-unauthenticatedUser"
                    animation="border"
                    variant="primary"
                />
            ) : (
                <>
                    {proxyList ? (
                        <HeaderGridContainer
                            container
                            justifyContent={'space-between'}
                            direction="row"
                        >
                            <HeaderTextContainer
                                item
                                xs={12}
                                sm={3}
                                md={3}
                                lg={3}
                                xl={3}
                                mobile={12}
                            >
                                {t('proxies.proxyname')}
                            </HeaderTextContainer>

                            <HeaderTextContainer
                                item
                                xs={12}
                                sm={4}
                                md={4}
                                lg={4}
                                xl={4}
                                mobile={12}
                            >
                                {t('proxies.validDates')}
                            </HeaderTextContainer>

                            <HeaderTextContainer
                                item
                                xs={12}
                                sm={3}
                                md={3}
                                lg={3}
                                xl={3}
                                mobile={12}
                            >
                                {t('proxies.created')}
                            </HeaderTextContainer>

                            <HeaderTextContainer
                                item
                                xs={12}
                                sm={2}
                                md={2}
                                lg={2}
                                xl={2}
                                mobile={6}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                {t('proxies.action')}
                            </HeaderTextContainer>
                        </HeaderGridContainer>
                    ) : (
                        <BodyTextContainer>
                            {t('proxies.noproxyforyou')}
                        </BodyTextContainer>
                    )}
                    <AccountListContainer>
                {proxyList &&
                    proxyList
                        .sort(function (a, b) {
                            return a.user.displayName.split(' ')[1] >
                                b.user.displayName.split(' ')[1]
                                ? 1
                                : b.user.displayName.split(' ')[1] >
                                  a.user.displayName.split(' ')[1]
                                ? -1
                                : 0;
                        })
                        .map((listData, index) => {
                            return (
                                <BodyGridContainer
                                    container
                                    key={index}
                                    // justifyContent={'space-between'}
                                >
                                    <Name
                                        item
                                        xs={12}
                                        sm={3}
                                        md={3}
                                        lg={3}
                                        xl={3}
                                        mobile={12}
                                    >
                                        <User1>
                                            <span className="admin-person-name-dt-mask">{listData.proxyEmployee.displayName}</span>
                                        </User1>
                                        <Designation1>
                                            {
                                                listData.proxyEmployee
                                                    .employeeRole
                                            }
                                        </Designation1>
                                    </Name>
                                    <Container2>
                                        <ValidDateHeadingMob mobile={12}>
                                            {t(
                                                'proxies.updateAProxy.validDates'
                                            )}
                                        </ValidDateHeadingMob>
                                        {loading ? (
                                            <Spinner
                                                id="app-loading-spinner-validDate"
                                                animation="border"
                                                variant="primary"
                                            />
                                        ) : (
                                            <ValidDateMob>
                                                {getDisplayDateNoTZ(listData.fromDate)}{' '}
                                                {t('proxies.updateAProxy.to')}{' '}
                                                {listData.toDate
                                                    ? getDisplayDateNoTZ(listData.toDate)
                                                    : t('proxies.noEndDate')}{' '}
                                            </ValidDateMob>
                                        )}
                                    </Container2>
                                    <ValidDate
                                        item
                                        xs={12}
                                        sm={4}
                                        md={4}
                                        lg={4}
                                        xl={4}
                                        mobile={12}
                                    >
                                        {getDisplayDateNoTZ(listData.fromDate)}{' '}
                                        {t('proxies.updateAProxy.to')}{' '}
                                        {listData.toDate
                                            ? getDisplayDateNoTZ(listData.toDate)
                                            : t('proxies.noEndDate')}{' '}
                                    </ValidDate>
                                    <Container2>
                                        <CreatedByMob>
                                            {t('proxies.createdby')}
                                        </CreatedByMob>
                                    </Container2>
                                    <Created
                                        item
                                        xs={12}
                                        sm={3}
                                        md={3}
                                        lg={3}
                                        xl={3}
                                        mobile={12}
                                    >
                                        <UserName>
                                            <span className="admin-person-name-dt-mask">{listData.createdByEmployee
                                                    .displayName}</span>
                                        </UserName>
                                        <Designation3>
                                            {
                                                listData.createdByEmployee
                                                    .employeeRole
                                            }
                                        </Designation3>
                                        <Designation2>
                                            {
                                                listData.createdByEmployee
                                                    .employeeRole
                                            }
                                        </Designation2>
                                        <LineMob>|</LineMob>
                                        <Date>
                                            {' '}
                                            {getDisplayDateNoTZ(
                                                listData.creationDate
                                            )}
                                        </Date>
                                    </Created>
                                    <EditContainerMain>
                                        <EditIconContainer>
                                            <EditContainer>
                                                <a
                                                    style={{
                                                        display: 'flex',
                                                        marginLeft: '4px',
                                                    }}
                                                    onClick={() =>
                                                        openUpdateProxy(
                                                            listData
                                                        )
                                                    }
                                                >
                                                    <StyledImage
                                                        src={Edit}
                                                        width="20px"
                                                        height="23px"
                                                    />
                                                    <ButtonLabel1>
                                                        {t('proxies.edit')}
                                                    </ButtonLabel1>
                                                </a>
                                            </EditContainer>
                                        </EditIconContainer>
                                    </EditContainerMain>
                                    {/* <Line></Line> */}

                                    {listData.address &&
                                        listData.address.map(
                                            (address, index) => {
                                                return (
                                                    <div
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        key={index}
                                                    >
                                                        <Line></Line>
                                                        <div
                                                            style={{
                                                                display:
                                                                    window.innerWidth >=
                                                                    sizes.mobileDevice
                                                                        ? 'flex'
                                                                        : 'block',
                                                                justifyContent:
                                                                    'space-between',
                                                            }}
                                                        >
                                                            <DistrictGrid
                                                                item
                                                                xs={12}
                                                                sm={5}
                                                                md={5}
                                                                lg={5}
                                                                xl={3}
                                                                mobile={12}
                                                                style={{
                                                                    marginLeft:
                                                                        '4.4%',
                                                                }}
                                                            >
                                                                <DistrictHeading>
                                                                    {t(
                                                                        'proxies.district'
                                                                    )}
                                                                </DistrictHeading>
                                                                <DistrictName>
                                                                    {
                                                                        address.district
                                                                    }
                                                                </DistrictName>
                                                            </DistrictGrid>

                                                            <DistrictGridMob
                                                                item
                                                                xs={12}
                                                                sm={3}
                                                                md={3}
                                                                lg={3}
                                                                xl={3}
                                                                mobile={12}
                                                                style={{
                                                                    textAlign:
                                                                        'left',
                                                                }}
                                                            >
                                                                <DistrictHeading>
                                                                    {t(
                                                                        'proxies.district'
                                                                    )}
                                                                </DistrictHeading>
                                                                <DistrictName>
                                                                    {
                                                                        address.district
                                                                    }
                                                                </DistrictName>
                                                            </DistrictGridMob>
                                                            {address.territory && (
                                                                <>
                                                                    <TerritoryGrid
                                                                        item
                                                                        xs={12}
                                                                        sm={6}
                                                                        md={6}
                                                                        lg={6}
                                                                        xl={4}
                                                                        mobile={
                                                                            12
                                                                        }
                                                                        style={{
                                                                            marginLeft:
                                                                            '19%',
                                                                        }}
                                                                    >
                                                                        <TerritoryHeading>
                                                                            {t(
                                                                                'proxies.territory'
                                                                            )}
                                                                        </TerritoryHeading>
                                                                        <TerritoryName isMobile={false}>
                                                                            {
                                                                                address.territory
                                                                            }
                                                                        </TerritoryName>
                                                                    </TerritoryGrid>

                                                                    <TerritoryGridMob
                                                                        item
                                                                        xs={12}
                                                                        sm={4}
                                                                        md={4}
                                                                        lg={4}
                                                                        xl={4}
                                                                        mobile={
                                                                            12
                                                                        }
                                                                        style={{
                                                                            textAlign:
                                                                                'left',
                                                                        }}
                                                                    >
                                                                        <TerritoryHeading>
                                                                            {t(
                                                                                'proxies.territory'
                                                                            )}
                                                                        </TerritoryHeading>
                                                                        <TerritoryName isMobile={true}>
                                                                            {
                                                                                address.territory
                                                                            }
                                                                        </TerritoryName>
                                                                    </TerritoryGridMob>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            }
                                        )}
                                </BodyGridContainer>
                            );
                        })}
                {updateProxyPopup && (
                    <Popup id={'admin-proxyTab1-Tab2-index-popup'} contentWidth={'50%'} margin={'15px'}>
                        <PopupContainer>
                            <UpdateProxy
                                setLoader={setLoader}
                                addProxyPopup={updateProxy}
                                handleClose={closeUpdateProxy}
                                isFromAccount={props.isFromAccount}
                                proxyData={proxyData}
                            />
                        </PopupContainer>
                    </Popup>
                )}
            </AccountListContainer>
                </>
            )}
        </>
    );
};
export default ProxiesTabs2;
